module.exports = __webpack_public_path__ + "img/divide58-1.9dde9c39.svg";